import pkg from '../../package.json';

export const getRemoteVersion = () =>
  fetch(`${location.origin}/version.json`)
    .then((res) => res.json())
    .then(({ commit_sha }) => commit_sha)
    .catch(() => pkg.version);
